import React, { Component } from "react";
import { MdSearch, MdClose } from "react-icons/md";
import { IconButton, TextField } from "@material-ui/core";
import { observer } from "mobx-react";
import { InputAdornment } from "@material-ui/core";
import styled, { css } from "styled-components";

function Find({ store }) {
  const { quickSearchText: value, handleQuickSearchChange: onChange } = store;
  const [isOpen, setOpen] = React.useState(!!value);
  React.useEffect(() => {
    setOpen(!!value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store]);

  return (
    <div className="d-flex" style={{ alignItems: "center" }}>
      {isOpen ? (
        <div className="d-flex">
          <StyledTextField
            id="findText"
            label="Find in entire sheet"
            variant="outlined"
            size="small"
            autoFocus={true}
            value={value}
            onChange={(e) => {
              if (store && store.isLazyLoadEnabled) {
                store.gridApi?.clearRangeSelection();
                store.gridApi?.clearFocusedCell();
              }
              onChange(e.target.value);
            }}
            InputProps={{
              endAdornment: value && (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      onChange("");
                    }}
                    size="small"
                  >
                    <MdClose />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <IconButton
            onClick={() => {
              setOpen(false);
              onChange("");
            }}
            size="small"
          >
            <MdClose />
          </IconButton>
        </div>
      ) : (
        <IconButton onClick={() => setOpen(true)}>
          <MdSearch />
        </IconButton>
      )}
    </div>
  );
}

const StyledTextField = styled(TextField)`
  ${(props) =>
    props.value &&
    css`
      background-color: #fde68a;
    `}
`;

export default observer(Find);
